import React from 'react';
import { Link } from 'react-router-dom';

const ProgramPage = () => {
  return (
    <div className="min-h-screen bg-white text-gray-900 relative overflow-hidden">

      {/* Background Vibes */}
      <div className="absolute inset-0 z-[-1] pointer-events-none">
        <div className="w-full h-full bg-[radial-gradient(circle_at_center,#dbeafe_0%,transparent_70%)] opacity-50" />
        <div className="absolute top-0 right-0 w-72 h-72 bg-blue-200 rounded-full filter blur-3xl opacity-30 animate-pulse-slow" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-yellow-100 rounded-full filter blur-3xl opacity-30 animate-pulse-slow delay-100" />
      </div>

      <main className="max-w-5xl mx-auto px-6 py-20 md:py-32 relative z-10">
        {/* Title */}
        <h1 className="text-4xl md:text-6xl font-extrabold text-center mb-10 text-blue-900 animate-fade-in tracking-tight">
          🌟 Program Overview
        </h1>

        {/* Event Info */}
        <div className="grid md:grid-cols-2 gap-12 mb-20 animate-fade-in delay-200">
          <div>
            <h2 className="text-2xl font-bold mb-3 text-yellow-600">📍 Location Of The Training</h2>
            <p className="text-lg text-gray-800 font-medium leading-relaxed">
              Addis Ababa Science and Technology University (AASTU)<br />
              Addis Ababa, Ethiopia</p>
          </div>
          <div>
            <h2 className="text-2xl font-bold mb-3 text-yellow-600">📅 Date</h2>
            <p className="text-lg text-gray-800 font-medium leading-relaxed">
              July 8, 2025<br />
              (4 weeks of full immersion)
              <br/>
              (4 weeks of project development)
              <br/>
              (And More)
            </p>
          </div>
          <div>
            <h2 className="text-2xl font-bold mb-3 text-yellow-600">HOSTED BY</h2>
            <p className="text-lg text-gray-800 font-medium leading-relaxed">
              INFORMATION NETWORK SECURITY ADMINSTRATION (INSA)
            </p>
          </div>
        </div>

        {/* What to Expect Section */}
        <div className="bg-blue-50 border border-blue-100 rounded-3xl p-8 md:p-12 shadow-lg animate-fade-in delay-300">
          <h2 className="text-3xl font-semibold text-blue-900 mb-6">🎯 What to Expect</h2>
          <ul className="space-y-5 text-lg text-blue-800 font-medium list-disc pl-6">
            <li>💻 Hands-on training in cybersecurity, ethical hacking, and secure coding</li>
            <li>🧠 Workshops with top local and international experts</li>
            <li>🤝 Team-based problem solving & national challenges</li>
            <li>🎉 Networking, mentorship, and fun side activities</li>
            <li>🏅 Certification, awards, and career insights</li>
          </ul>
        </div>

        {/* CTA Button */}
        <div className="text-center mt-16">
          <Link
            to="/register"
            className="inline-block bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white text-lg md:text-xl font-semibold px-10 py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 animate-fade-in delay-500"
          >
            Register for the Program
          </Link>
        </div>
      </main>
    </div>
  );
};

export default ProgramPage;
